<template>
  <div class="page-box page" style="background:#091e2b;">
    <!-- <vue-particles color="#2BD3A0" style="position:absolute;width:100%;height:100%;zIdex:-1;"
      ></vue-particles> -->
    <div class="page-top"></div>
    <div class="mapTitle" ref="mapTitle">
      <p class="index-common_title tc" style="color:#fff">
          遍布全国节点布局
      </p>
      <p class="index-common_subtitle tc" style="color:#fff">
          持续扩张的数据中心让跨域体验更流畅
      </p>
    </div>
  <div class="mapService" ref="mapService">
		<div class="chinaMap" ref="chinaMap">
			<div class="region-list postition-1">
				<div class="area-box">
					<span class="dot"></span>
					<span class="pulse delay-01"></span>
					<span class="pulse delay-02"></span>
				</div>
			</div>
			<div class="region-list active postition-2 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
					<span class="pulse delay-05"></span>
					<span class="pulse delay-04"></span></div>
				<div class="show-regin"><span>四川</span></div>
			</div>
			<div class="region-list postition-3">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-01"></span>
					<span class="pulse delay-02"></span>
					</div>
			</div>
			<div class="region-list waite postition-4 waite-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-01"></span>
					<span class="pulse delay-02"></span>
					</div>
				<div class="show-regin"><span>西藏</span></div>
			</div>
			<div class="region-list waite postition-5 waite-node" style="display:none;">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-01"></span>
					<span class="pulse delay-02"></span>
					</div>
				<div class="show-regin"><span>湖北</span></div>
			</div>
			 <div class="region-list active postition-6 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
					<span class="pulse delay-05"></span>
					<span class="pulse delay-04"></span></div>
				<div class="show-regin"><span>广东</span></div>
			</div>
			<div class="region-list active postition-13 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-04"></span>
					<span class="pulse delay-05"></span>
					<span class="pulse delay-03"></span></div>
				<div class="show-regin"><span>内蒙古</span></div>
			</div>
			<div class="region-list  active  postition-11 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
					<span class="pulse delay-05"></span>
					<span class="pulse delay-04"></span></div>
				<div class="show-regin"><span>山东</span></div>
			</div>
			<div class="region-list active postition-7 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>辽宁</span></div>
			</div>
			<div class="region-list active postition-8 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
					<span class="pulse delay-05"></span>
					<span class="pulse delay-04"></span>
          </div>
				<div class="show-regin"><span>北京</span></div>
			</div>
			<div class="region-list active postition-9 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>江苏</span></div>
			</div>
			<div class="region-list active postition-10 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-06"></span>
					<span class="pulse delay-05"></span>
					<span class="pulse delay-04"></span></div>
				<div class="show-regin"><span>香港</span></div>
			</div>
      <div class="region-list active postition-16 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>青海</span></div>
			</div>
       <div class="region-list active postition-17 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>乌鲁木齐</span></div>
			</div>
       <div class="region-list active postition-18 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>新疆</span></div>
			</div>
       <div class="region-list active postition-19 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>云南</span></div>
			</div>
       <div class="region-list active postition-20 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>厦门</span></div>
			</div>
       <div class="region-list active postition-21 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>福建</span></div>
			</div>
       <div class="region-list active postition-22 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>上海</span></div>
			</div>
       <div class="region-list active postition-23 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>宁夏</span></div>
			</div>
       <div class="region-list active postition-24 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>贵州</span></div>
			</div>
       <div class="region-list active postition-25 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>湖南</span></div>
			</div>
       <div class="region-list active postition-26 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>重庆</span></div>
			</div>
       <div class="region-list active postition-27 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>山西</span></div>
			</div>
       <div class="region-list active postition-28 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>河南</span></div>
			</div>
       <div class="region-list active postition-29 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>安徽</span></div>
			</div>
       <div class="region-list active postition-30 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>江西</span></div>
			</div>
       <div class="region-list active postition-31 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>吉林</span></div>
			</div>
       <div class="region-list active postition-32 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>黑龙江</span></div>
			</div>
       <div class="region-list active postition-33 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>海南</span></div>
			</div>
       <div class="region-list active postition-34 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>广西</span></div>
			</div>
      <!-- <div class="region-list active postition-35 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>广西</span></div>
			</div> -->
      <div class="region-list active postition-36 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>湖北</span></div>
			</div>
      <div class="region-list active postition-37 online-node">
				<div class="area-box"><span class="dot"></span><span class="pulse delay-10"></span>
					<span class="pulse delay-09"></span>
					<span class="pulse delay-08"></span></div>
				<div class="show-regin"><span>甘肃</span></div>
			</div>
		</div>
</div>
  </div>
</template>

<script>
export default {
  name: 'chinamap',
  props: {
    map_animation: Boolean
  },
  watch: {
    map_animation () {
      if(this.map_animation){
          this.$refs.mapTitle.classList.add("mapTitleAn")
          this.$refs.chinaMap.classList.add("mapTitleAn")
      }
    }
  }
}
</script>

<style scoped>
  .page-top{
    border-color: #f3f3f3 transparent transparent;
  }
  .mapTitle{
    transition: all 1s ease;
    transform: translateY(100px);
    opacity: 0;
  }
  .mapService {
    display: flex;
    justify-content: center;
  }
  .chinaMap {
    width: 17rem;
    height: 10rem;
    background: url(~@/assets/img/index_img/map_black_bg.png) center no-repeat;
    position: relative;
    transition: all 1s ease;
    transform: translateY(-100px);
    opacity: 0;
  }
  .chinaMapAn,.mapTitleAn{
    transform: translateY(0px);
    opacity: 1;
  }
  @media screen and (max-width: 758px){
    .chinaMap{
      width: 14rem;
      height: 7rem;
      background-size: 100% 100%
    }
    .area-box .dot{
      width: 5px;
      height: 5px;
    }
  }
  .region-list {
    position: absolute;
    left: 0;
    top: 0;
  }
  @keyframes warn {
    0% {
      -webkit-transform: scale(0);
      -moz-transform: scale(0);
      -o-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(.56);
      -moz-transform: scale(.56);
      -o-transform: scale(.56);
      transform: scale(.56);
      opacity: 0;
    }
  }
  .area-box .dot {
    position: absolute;
    left: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #a2a9b4;
    opacity: 1;
    filter: alpha(opacity=100);
  }
  .area-box .pulse {
    position: absolute;
    top: -16px;
    left: -17px;
    height: 43px;
    width: 43px;
    border: 2px solid #b7b7b7;
    border-radius: 48px;
    box-shadow: 0 0 4px #82878f, 0 0 10px #82878f inset;
    opacity: 0.12;
    filter: alpha(opacity=0);
    animation: warn 2s ease-out both;
    animation-iteration-count: infinite;
    background: 0 0;
  }
  .area-box .delay-01 {
    animation-delay: 0;
  }
  .area-box .delay-02 {
    animation-delay: 0.4s;
  }
  .area-box .delay-03 {
    animation-delay: 0.8s;
  }
  .area-box .delay-04 {
    animation-delay: 1.2s;
  }
  .area-box .delay-05 {
    animation-delay: 1.6s;
  }
  .area-box .delay-06 {
    animation-delay: 2s;
  }
  .area-box .delay-07 {
    animation-delay: 2.4s;
  }
  .area-box .delay-08 {
    animation-delay: -0.4s;
  }
  .area-box .delay-09 {
    animation-delay: -0.8s;
  }
  .area-box .delay-10 {
    animation-delay: -1.2s;
  }
  .area-box .delay-11 {
    animation-delay: 4s;
  }
  .region-list.active .area-box .dot {
    background: #2BD3A0;
  }
  .region-list.active .area-box .pulse {
    border-color: #2BD3A0;
    top: -39px;
    left: -39px;
    height: 88px;
    width: 88px;
    box-shadow: 0 0 12px #2BD3A0, 0 0 20px #2BD3A0 inset;
  }
  .region-list.waite .area-box .dot {
    background: #f90;
  }
  .region-list.waite .area-box .pulse {
    border-color: #f90;
  }
  .show-regin {
    position: absolute;
    left: 2px;
    height: 0;
    top: 0;
    width: 11px;
    opacity: 0;
    transition: all 0.5s ease-in-out;
  }
  .online-node .show-regin,
  .region-list:hover .show-regin,
  .underline-node .show-regin,
  .waite-node .show-regin {
    height: 127px;
    opacity: 1;
  }
  .show-regin span {
    width: 44px;
    position: absolute;
    left: 8px;
    top: -11px;
    padding: 6px 10px;
    font-size: 14px;
    color: #ccc;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    text-align: center;
    white-space: nowrap;
  }
  .postition-10 .show-regin span {
    left: 0;
  }
  .postition-6 .show-regin span {
    left: 4px;
  }
  .area-box {
    z-index: 77;
  }
  .show-regin {
    z-index: 66;
  }
  .region-list{
    z-index: 11;
  }
  .region-list.active .show-regin span {
    position: relative;
    color: #ccc;
  }
  .region-list.waite .show-regin span {
    color: #ccc;
  }
  .postition-1 {
    left: 75%;
    top: 80%;
  }
  .postition-2 {
    left: 50%;
    top: 66%;
  }
  .postition-3 {
    left: 45%;
    top: 82%;
    display: none;
  }
  .postition-4 {
    left: 25%;
    top: 59%;
  }
  .postition-5 {
    left: 66%;
    top: 60%;
  }
  .postition-6 {
    left: 67%;
    top: 80%;
  }
  .postition-7 {
    left: 75%;
    top: 32%;
  }
  .postition-16{
    left: 38%;
    top: 51%;
  }
  .postition-17{
    left: 32%;
    top: 34%;
  }
  .postition-18{
    left: 23%;
    top: 36%;
  }
  .postition-19{
    left: 48%;
    top: 80%;
  }
   .postition-20{
    left: 65%;
    top: 86%;
  }
  .postition-21{
    left: 71%;
    top: 75%;
  }
   .postition-22{
    left: 73%;
    top: 66%;
  }
   .postition-23{
    left: 56%;
    top: 46%;
  }
   .postition-24{
    left: 58%;
    top: 74%;
  }
   .postition-25{
    left: 64%;
    top: 72%;
  }
   .postition-26{
    left: 56%;
    top: 55%;
  }
   .postition-27{
    left: 66%;
    top: 48%;
  }
   .postition-28{
    left: 68%;
    top: 55%;
  }
   .postition-29{
    left: 71%;
    top: 60%;
  }
   .postition-30{
    left: 73%;
    top: 72%;
  }
   .postition-31{
    left: 76%;
    top: 25%;
  }
   .postition-32{
    left: 75%;
    top: 16%;
  }
  .postition-33{
    left: 60%;
    top: 95%;
  }
  .postition-34{
    left: 60%;
    top: 82%;
  }
  .postition-35{
    left: 80%;
    top: 66%;
  }
  .postition-36{
    left: 62%;
    top: 60%;
  }
  .postition-37{
    left: 48%;
    top: 44%;
  }
  .postition-38{
    left: 80%;
    top: 66%;
  }
  .postition-39{
    left: 80%;
    top: 66%;
  }

  .postition-40{
    left: 80%;
    top: 66%;
  }
  .postition-41{
    left: 80%;
    top: 66%;
  }
  .postition-42{
    left: 80%;
    top: 66%;
  }
  .postition-43{
    left: 80%;
    top: 66%;
  }
  .postition-44{
    left: 80%;
    top: 66%;
  }


  .postition-7.region-list.active .area-box .pulse {
    top: -50px;
    left: -50px;
    width: 110px;
    height: 110px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
  .postition-8 {
    left: 70%;
    top: 36%;
  }
  .postition-9 {
    left: 72%;
    top: 56%;
  }
  .postition-9.region-list.active .area-box .pulse {
    top: -50px;
    left: -50px;
    width: 110px;
    height: 110px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
  .postition-10 {
    left: 69%;
    top: 83%;
  }
  .postition-11 {
    left: 72%;
    top: 50%;
  }
  .postition-13 {
    left: 59%;
    top: 38%;
  }
  .douhao {
    width: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/components/chinamap.vue